import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { FileText, Shield, CheckCircle } from 'lucide-react';
import { Button } from './ui/button';

export const WhatIsTOR1 = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-20 bg-white" aria-labelledby="what-is-tor1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 id="what-is-tor1" className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            What is a TOR1 Form?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            The TOR1 form is your gateway to duty-free relocation back to the UK
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              The <strong>Transfer of Residence (TOR1) form</strong> is an official HMRC document that allows UK nationals and residents returning to the UK after living abroad to bring their personal belongings and furniture without paying customs duty or VAT.
            </p>
            
            <div className="space-y-4 mb-8">
              <div className="flex items-start">
                <CheckCircle className="text-green-500 mr-3 mt-1 flex-shrink-0" size={24} />
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">Duty-Free Import</h3>
                  <p className="text-gray-600">Bring your belongings back without paying customs charges</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <CheckCircle className="text-green-500 mr-3 mt-1 flex-shrink-0" size={24} />
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">HMRC Approved</h3>
                  <p className="text-gray-600">Official UK government customs relief program</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <CheckCircle className="text-green-500 mr-3 mt-1 flex-shrink-0" size={24} />
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">Save Thousands</h3>
                  <p className="text-gray-600">Avoid duty and 20% VAT on furniture and personal items</p>
                </div>
              </div>
            </div>

            <Button 
              size="lg" 
              className="bg-blue-900 hover:bg-blue-800"
              onClick={() => scrollToSection('contact')}
            >
              Get TOR1 Application Help
            </Button>
          </div>

          <div className="grid grid-cols-1 gap-6">
            <Card className="border-none shadow-lg bg-blue-50">
              <CardHeader>
                <FileText className="text-blue-900 mb-2" size={32} />
                <CardTitle className="text-xl">Who Needs TOR1?</CardTitle>
              </CardHeader>
              <CardContent>
                <ul className="space-y-2 text-gray-700">
                  <li>• UK nationals living abroad for 12+ months</li>
                  <li>• Returning permanently to the UK</li>
                  <li>• Bringing personal belongings and furniture</li>
                  <li>• Moving from Spain, France, Dubai, or anywhere</li>
                </ul>
              </CardContent>
            </Card>

            <Card className="border-none shadow-lg bg-green-50">
              <CardHeader>
                <Shield className="text-green-700 mb-2" size={32} />
                <CardTitle className="text-xl">Why Apply?</CardTitle>
              </CardHeader>
              <CardContent>
                <ul className="space-y-2 text-gray-700">
                  <li>• Avoid 2-5% customs duty charges</li>
                  <li>• Skip 20% VAT on goods value</li>
                  <li>• Legal and government-approved</li>
                  <li>• Smooth customs clearance</li>
                </ul>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};
